import abTests from '@/js/common/Domain/Service/abTests';
import { ExWindow } from '@ve/types';

declare let window: ExWindow;
export default () => {
    const isAbkhaziaPage = window.appConfig?.defaultTourCriteria?.country === 1
    if (abTests.hasTest('TF-1928') && isAbkhaziaPage) {
        window.appConfig.showMindboxPopups = true
    }
};
